import { render, staticRenderFns } from "./RegistrationAnalysis.vue?vue&type=template&id=1e60e35c&scoped=true"
import script from "./RegistrationAnalysis.vue?vue&type=script&lang=js"
export * from "./RegistrationAnalysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e60e35c",
  null
  
)

export default component.exports